import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate  } from 'react-router-dom';
import { getCardCheckerCard } from '../../areas/cards/selectors';

const Requirements = {
    SpotCheck: 'spotCheck',
    Swipes: 'swipes',
    None: 'none'
};

function authenticate({ cardChecker, requirements, loggedIn }) {
    let canAccess = loggedIn || requirements === Requirements.None;

    if (cardChecker && canAccess && requirements !== Requirements.None) {
        if (requirements === Requirements.SpotCheck) {
            canAccess = cardChecker.canPerformSpotCheck;
        } else if (requirements === Requirements.Swipes) {
            canAccess = cardChecker.canSwipeCards;
        }
        return canAccess;

    }
}

function RequireAuth({ children, redirectTo, alt, ...props }) {

    let isAuthenticated = authenticate(props);
    if (!isAuthenticated && alt) {
        redirectTo = alt;
    }
    return isAuthenticated ? children : <Navigate  to={redirectTo} />
}

RequireAuth.propTypes = {
    redirectTo: PropTypes.string,
    requirements: PropTypes.oneOf([
        Requirements.None,
        Requirements.Swipes,
        Requirements.SpotCheck
    ])

};

function mapStateToProps(state) {
    const { auth } = state;
    const processedCardCheckerCard = getCardCheckerCard(state);
    return {
        loggedIn: auth.loggedIn,
        cardChecker: processedCardCheckerCard
    }
}

export default connect(mapStateToProps)(RequireAuth);